/** Largest authored size whose length the run reaches. Shared by scene runs and spell sections. */
const WALL_RUN_SIZE_LADDER: ReadonlyArray<{ baseFt: number; id: string }> = [
  { baseFt: 30, id: '4C33FD22-5382-15DA-1C46-F57F14378AFD' },
  { baseFt: 25, id: 'C94CDD74-8ACD-26B0-5C53-4CA29CF21D68' },
  { baseFt: 20, id: 'CEA2946E-D395-46EA-A6E7-74D21EA2376E' },
  { baseFt: 15, id: 'D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C' },
  { baseFt: 10, id: '52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD' },
  { baseFt: 5, id: 'DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC' },
  { baseFt: 3.75, id: 'AAC1F466-7A8B-C593-1ADC-FC402B8909D7' },
  { baseFt: 0, id: '13456FEC-A2EE-DB46-5829-0EB2F627E1B7' },
];
export function wallRunSizeIdForLength(lengthFt: number): string {
  return (WALL_RUN_SIZE_LADDER.find(step => lengthFt >= step.baseFt - 1e-6) ?? WALL_RUN_SIZE_LADDER[WALL_RUN_SIZE_LADDER.length - 1]!).id;
}
